// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddAudioChapter_container__I7Ryk {
  padding: 24px;
  background-color: #121212;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  margin-bottom: 20px;
  color: #f5f5f5;
}

.AddAudioChapter_title__U9RGm {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 24px;
  color: #ffffff;
  border-bottom: 2px solid #ff3333;
  padding-bottom: 10px;
}

.AddAudioChapter_form__ixFk8 {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.AddAudioChapter_formGroup__hXRWp {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.AddAudioChapter_label__vK\\+05 {
  font-weight: 500;
  font-size: 0.95rem;
  color: #cccccc;
}

.AddAudioChapter_input__oZcl2, .AddAudioChapter_select__Sj1py {
  padding: 10px 14px;
  border-radius: 6px;
  border: 1px solid #333333;
  background-color: #1e1e1e;
  color: #f0f0f0;
  font-size: 1rem;
  transition: all 0.2s ease;
}

.AddAudioChapter_previewImg__kMqUx{
  width: 200px;
  height: 250px;
}

.AddAudioChapter_select__Sj1py option {
  background-color: #1e1e1e;
  color: #f0f0f0;
}

.AddAudioChapter_submitButton__qB4Pv {
  background-color: #ff3333;
  color: white;
  padding: 12px;
  border-radius: 6px;
  border: none;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
  margin-top: 10px;
}

.AddAudioChapter_submitButton__qB4Pv:hover {
  background-color: #e61919;
}

.AddAudioChapter_submitButton__qB4Pv:disabled {
  background-color: #666666;
  cursor: not-allowed;
}

/* Searchable Select Wrapper */
.AddAudioChapter_searchableSelect__14GF0 {
  position: relative;
  display: flex;
  align-items: center;
  background-color: #1e1e1e;
  border: 1px solid #333333;
  border-radius: 6px;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.AddAudioChapter_searchableSelect__14GF0:hover {
  border-color: #ff3333;
}

.AddAudioChapter_searchableSelect__14GF0 input {
  flex-grow: 1;
  background: transparent;
  border: none;
  color: #f0f0f0;
  font-size: 1rem;
  outline: none;
  width: 100%;
}

.AddAudioChapter_searchableSelect__14GF0 .AddAudioChapter_dropdownArrow__HwyZ2 {
  margin-left: 8px;
  font-size: 14px;
  color: #ff6666;
  transition: transform 0.2s ease;
}

.AddAudioChapter_searchableSelect__14GF0.AddAudioChapter_open__OfUff .AddAudioChapter_dropdownArrow__HwyZ2 {
  transform: rotate(180deg);
}

/* Dropdown List */
.AddAudioChapter_dropdownList__UGpjB {
 background-color: #1e1e1e;
  border: 1px solid #333333;
  border-radius: 6px;
  margin-top: 5px;
  list-style: none;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  animation: AddAudioChapter_fadeIn__wU--- 0.2s ease-in-out;
}

.AddAudioChapter_dropdownItem__ZlYsq {
  padding: 10px 14px;
  font-size: 1rem;
  color: #f0f0f0;
  transition: background 0.2s ease, color 0.2s ease;
  cursor: pointer;
}

.AddAudioChapter_dropdownItem__ZlYsq:hover {
  background-color: #ff3333;
  color: #ffffff;
}

.AddAudioChapter_dropdownItem__ZlYsq:empty {
  color: #888888;
  text-align: center;
}

.AddAudioChapter_dropdownList__UGpjB::-webkit-scrollbar {
  width: 6px;
}

.AddAudioChapter_dropdownList__UGpjB::-webkit-scrollbar-thumb {
  background: #ff3333;
  border-radius: 4px;
}

.AddAudioChapter_dropdownList__UGpjB::-webkit-scrollbar-track {
  background: #222222;
}

@keyframes AddAudioChapter_fadeIn__wU--- {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/admin/pages/Series/AddAudioChapter.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;CACC,yBAAyB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,wCAAwC;EACxC,yDAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iDAAiD;EACjD,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".container {\n  padding: 24px;\n  background-color: #121212;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  margin-bottom: 20px;\n  color: #f5f5f5;\n}\n\n.title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 24px;\n  color: #ffffff;\n  border-bottom: 2px solid #ff3333;\n  padding-bottom: 10px;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.formGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.label {\n  font-weight: 500;\n  font-size: 0.95rem;\n  color: #cccccc;\n}\n\n.input, .select {\n  padding: 10px 14px;\n  border-radius: 6px;\n  border: 1px solid #333333;\n  background-color: #1e1e1e;\n  color: #f0f0f0;\n  font-size: 1rem;\n  transition: all 0.2s ease;\n}\n\n.previewImg{\n  width: 200px;\n  height: 250px;\n}\n\n.select option {\n  background-color: #1e1e1e;\n  color: #f0f0f0;\n}\n\n.submitButton {\n  background-color: #ff3333;\n  color: white;\n  padding: 12px;\n  border-radius: 6px;\n  border: none;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  margin-top: 10px;\n}\n\n.submitButton:hover {\n  background-color: #e61919;\n}\n\n.submitButton:disabled {\n  background-color: #666666;\n  cursor: not-allowed;\n}\n\n/* Searchable Select Wrapper */\n.searchableSelect {\n  position: relative;\n  display: flex;\n  align-items: center;\n  background-color: #1e1e1e;\n  border: 1px solid #333333;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: border-color 0.2s ease;\n}\n\n.searchableSelect:hover {\n  border-color: #ff3333;\n}\n\n.searchableSelect input {\n  flex-grow: 1;\n  background: transparent;\n  border: none;\n  color: #f0f0f0;\n  font-size: 1rem;\n  outline: none;\n  width: 100%;\n}\n\n.searchableSelect .dropdownArrow {\n  margin-left: 8px;\n  font-size: 14px;\n  color: #ff6666;\n  transition: transform 0.2s ease;\n}\n\n.searchableSelect.open .dropdownArrow {\n  transform: rotate(180deg);\n}\n\n/* Dropdown List */\n.dropdownList {\n background-color: #1e1e1e;\n  border: 1px solid #333333;\n  border-radius: 6px;\n  margin-top: 5px;\n  list-style: none;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 10;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  animation: fadeIn 0.2s ease-in-out;\n}\n\n.dropdownItem {\n  padding: 10px 14px;\n  font-size: 1rem;\n  color: #f0f0f0;\n  transition: background 0.2s ease, color 0.2s ease;\n  cursor: pointer;\n}\n\n.dropdownItem:hover {\n  background-color: #ff3333;\n  color: #ffffff;\n}\n\n.dropdownItem:empty {\n  color: #888888;\n  text-align: center;\n}\n\n.dropdownList::-webkit-scrollbar {\n  width: 6px;\n}\n\n.dropdownList::-webkit-scrollbar-thumb {\n  background: #ff3333;\n  border-radius: 4px;\n}\n\n.dropdownList::-webkit-scrollbar-track {\n  background: #222222;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-5px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AddAudioChapter_container__I7Ryk`,
	"title": `AddAudioChapter_title__U9RGm`,
	"form": `AddAudioChapter_form__ixFk8`,
	"formGroup": `AddAudioChapter_formGroup__hXRWp`,
	"label": `AddAudioChapter_label__vK+05`,
	"input": `AddAudioChapter_input__oZcl2`,
	"select": `AddAudioChapter_select__Sj1py`,
	"previewImg": `AddAudioChapter_previewImg__kMqUx`,
	"submitButton": `AddAudioChapter_submitButton__qB4Pv`,
	"searchableSelect": `AddAudioChapter_searchableSelect__14GF0`,
	"dropdownArrow": `AddAudioChapter_dropdownArrow__HwyZ2`,
	"open": `AddAudioChapter_open__OfUff`,
	"dropdownList": `AddAudioChapter_dropdownList__UGpjB`,
	"fadeIn": `AddAudioChapter_fadeIn__wU---`,
	"dropdownItem": `AddAudioChapter_dropdownItem__ZlYsq`
};
export default ___CSS_LOADER_EXPORT___;
